import { lazy } from "react";

export { SURVEY_RESULT_BY_ID_PATH } from "./survey-result-by-id-path";
export const SurveyResultByIdPage = lazy(() => import("./survey-result-by-id"));
